import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, mergeMap, switchMap } from 'rxjs/operators';
import { IResponse } from 'src/app/core/interfaces/response.interface';
import { ErrorService } from 'src/app/services/error.service';
import * as AddressSelectorActions from '../actions/address-selector.actions';
import { IAddressSelector } from 'src/app/core/interfaces/address-selector.interface';

@Injectable()
export class AddressSelectorEffects {
  constructor(
    public actions$: Actions,
    public http: HttpClient,
    private errorService: ErrorService
  ) { }

  getAddressSelector$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AddressSelectorActions.readAddressSelector),
      switchMap(({ payload }) => {
        return this.http
          .get<IResponse<IAddressSelector[]>>(
            environment.apiUrl + '/addresses/selector',
            {
              params: {
                searchText: payload.searchText,
                searchBy: payload.searchBy

              },
            }
          )
          .pipe(
            mergeMap((response) => {
              return of(
                AddressSelectorActions.AddressSelectorRead({
                  payload: { addresssSelector: response.data },
                })
              );
            }),
            catchError((error) => {
              return of(
                AddressSelectorActions.AddressSelectorFail({
                  payload: { error: this.errorService.mapError(error) },
                })
              );
            })
          );
      })
    )
  );
}
